import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';
import { AUTH_CONFIG } from 'shared/core/data-access/auth';
import { AbstractUserInfoService } from 'shared/core/data-access/user-info';
import { UserInfo } from '../../models/user-info/user-info.model';

@Injectable({
    providedIn: 'root',
})
export class UserInfoService implements AbstractUserInfoService {
    #http = inject(HttpClient);
    #authConfig = inject(AUTH_CONFIG, { optional: true }) ?? {};
    #userInfoUri = `${this.#authConfig.basePath ?? ''}/userinfo`;

    get userInfoFragment() {
        return this.#userInfoUri.split('/').slice(-1)[0];
    }

    getUserInfo = () =>
        this.#http
            .get<UserInfo>(this.#userInfoUri)
            .pipe(catchError(() => of(undefined)));
}
